import { Link } from 'react-router-dom';
import { EnumPathRutas } from '../../../Utils/Enumeradores/ComunEnum';
import React, { useState } from "react";
import PlanificarCargaInformes from '../Components/PlanificarCargaInformes';

const PlanificarCargasPage = () => {
	return (
		<div className="container-fluid">
			<div className="row mb-4">
				<div className="col-12">
					<div className="breadcrumbs">
						<ul>
							<li><Link to={EnumPathRutas.Inicio}> Inicio</Link></li>
							<li><a href="" onClick={(e) => { e.preventDefault(); window.location.reload(false); }}>Informes Conservacion</a></li>
                            <li><a href="">Planificación</a></li>
						</ul>
					</div>
				</div>
			</div>
			<div className="row" style={{ height: 'calc(100% - 20px)' }}>
				<div className="col-12">
					<div className="bg-white rounded p-4 d-flex flex-column h-100">
							<PlanificarCargaInformes/>	
				    </div>	
                </div>
			</div>

		</div>
	)
}
export default PlanificarCargasPage;
